import React, { useEffect, useState } from "react";
import { Container } from "./styles";
import { useNavigate } from "react-router-dom";
import api from "../../../services/api";
import { toast } from "react-toastify";
import { MdAddPhotoAlternate, MdBook, MdDelete, MdEdit } from "react-icons/md";
import { IconButton } from "@mui/material";
import { Button, Input, Modal, Select, Spin } from "antd";
import { Card, Message, ViewInput } from "../../../GlobalStyles";

import { ExclamationCircleFilled } from "@ant-design/icons";
import CountUp from "react-countup";
const { confirm } = Modal;

export default function CoursesAdmin() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [visibleModal, setVisibleModal] = useState(false);
  const [visibleModalModule, setVisibleModalModule] = useState(false);
  const [courses, setCourses] = useState([]);
  const [filter, setFilter] = useState("");
  const [filterSearch, setFilterSearch] = useState("");
  const [photo, setPhoto] = useState("");
  const [name, setName] = useState("");
  const [module_id, setModule_id] = useState("");
  const [isLoadingModal, setIsLoadingModal] = useState(false);
  const [order, setOrder] = useState("");
  const [description, setDescription] = useState("");
  const [id, setId] = useState("");

  useEffect(() => {
    listCourses();
  }, [filterSearch]);

  async function listCourses() {
    await api
      .get(`/courses${filterSearch ? `?search=${filterSearch}` : ""}`)
      .then((response) => {
        setCourses(response.data);
      })
      .catch(({ response }) => {
        if (response) {
          if (response.data) {
            if (response.data.message) {
              toast.warn(response.data.message);
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente"
              );
            }
          } else {
            toast.error(
              "Erro Interno. verifique sua conexão e tente novamente"
            );
          }
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
    setLoading(false);
  }

  async function createAndEditCourse() {
    setIsLoadingModal(true);
    if (!name || !photo || !description || !module_id) {
      toast.warn(
        "Preencha name, descrição, modulo e envia uma imagem para criar novo curso"
      );
    } else {
      const data = new FormData();
      data.append("name", name);
      data.append("order", order);
      data.append("module_id", module_id);
      data.append("description", description);
      if (photo.name) {
        data.append("file", photo, photo.name);
      }
      if (id) {
        await api
          .put(`/course/${id}`, data)
          .then(async (ok) => {
            toast.success("Curso editado com sucesso");
            listCourses();
            setVisibleModal(false);
          })
          .catch((response) => {
            if (response) {
              if (response.data) {
                if (response.data.message) {
                  toast.warn(response.data.message);
                } else {
                  toast.error(
                    "Erro Interno. verifique sua conexão e tente novamente"
                  );
                }
              } else {
                toast.error(
                  "Erro Interno. verifique sua conexão e tente novamente"
                );
              }
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente"
              );
            }
          });
      } else {
        await api
          .post(`/course`, data)
          .then(async (ok) => {
            toast.success("Curso criado com sucesso");
            listCourses();
            setVisibleModal(false);
          })
          .catch((response) => {
            if (response) {
              if (response.data) {
                if (response.data.message) {
                  toast.warn(response.data.message);
                } else {
                  toast.error(
                    "Erro Interno. verifique sua conexão e tente novamente"
                  );
                }
              } else {
                toast.error(
                  "Erro Interno. verifique sua conexão e tente novamente"
                );
              }
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente"
              );
            }
          });
      }
    }
    setIsLoadingModal(false);
  }

  async function createAndEditModule() {
    setIsLoadingModal(true);
    if (!name || !description) {
      toast.warn("Preencha name e descrição novo modulo");
    } else {
      if (id) {
        await api
          .put(`/module/${id}`, {
            name: name,
            description: description,
            order: order,
          })
          .then(async (ok) => {
            toast.success("Modulo editado com sucesso");
            listCourses();
            setVisibleModalModule(false);
          })
          .catch((response) => {
            if (response) {
              if (response.data) {
                if (response.data.message) {
                  toast.warn(response.data.message);
                } else {
                  toast.error(
                    "Erro Interno. verifique sua conexão e tente novamente"
                  );
                }
              } else {
                toast.error(
                  "Erro Interno. verifique sua conexão e tente novamente"
                );
              }
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente"
              );
            }
          });
      } else {
        await api
          .post(`/module`, {
            name: name,
            description: description,
            order: order,
          })
          .then(async (ok) => {
            toast.success("Modulo criado com sucesso");
            listCourses();
            setVisibleModalModule(false);
          })
          .catch((response) => {
            if (response) {
              if (response.data) {
                if (response.data.message) {
                  toast.warn(response.data.message);
                } else {
                  toast.error(
                    "Erro Interno. verifique sua conexão e tente novamente"
                  );
                }
              } else {
                toast.error(
                  "Erro Interno. verifique sua conexão e tente novamente"
                );
              }
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente"
              );
            }
          });
      }
    }
    setIsLoadingModal(false);
  }

  async function deleteCourse(id) {
    await api
      .delete(`/course/${id}`)
      .then(() => {
        toast.success("Curso excluido com sucesso");
        listCourses();
      })
      .catch(({ response }) => {
        if (response) {
          if (response.data) {
            if (response.data.message) {
              toast.warn(response.data.message);
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente"
              );
            }
          } else {
            toast.error(
              "Erro Interno. verifique sua conexão e tente novamente"
            );
          }
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
  }

  async function deleteModule(id) {
    await api
      .delete(`/module/${id}`)
      .then(() => {
        toast.success("Modulo excluido com sucesso");
        listCourses();
      })
      .catch(({ response }) => {
        if (response) {
          if (response.data) {
            if (response.data.message) {
              toast.warn(response.data.message);
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente"
              );
            }
          } else {
            toast.error(
              "Erro Interno. verifique sua conexão e tente novamente"
            );
          }
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
  }

  return (
    <Container>
      <h1>Modulos</h1>
      <Card>
        <p>Total</p>
        <CountUp duration={1} end={courses.length} />
      </Card>
      <div className="filter">
        <ViewInput style={{ flex: 1, maxWidth: 350 }}>
          <p>Pesquisar</p>
          <Input.Search
            value={filter}
            onChange={(text) => {
              setFilter(text.target.value);
            }}
            placeholder="pesquisar"
            onSearch={(text) => {
              setFilterSearch(text);
            }}
            allowClear
            onClear={() => {
              setFilterSearch("");
            }}
            enterButton
          />
        </ViewInput>
        <Button
          type="primary"
          style={{
            marginTop: 17,
            marginLeft: 50,
            borderRadius: 50,
            marginRight: 15,
          }}
          onClick={() => {
            setId("");
            setName("");
            setDescription("");
            setPhoto("");
            setOrder("");
            setVisibleModalModule(true);
          }}
        >
          Novo Modulo
        </Button>
        <Button
          type="primary"
          style={{
            marginTop: 17,
            borderRadius: 50,
            marginRight: 15,
          }}
          onClick={() => {
            setId("");
            setName("");
            setDescription("");
            setOrder("");
            setModule_id(null);
            setVisibleModal(true);
          }}
        >
          Novo Curso
        </Button>
      </div>
      {loading ? (
        <Spin size="large" style={{ marginTop: 50 }} />
      ) : (
        <>
          {courses.length == 0 && <Message>Nenhum modulo encontrado</Message>}
          {courses.map((item) => {
            return (
              <div>
                <div className="title">
                  <h4>{item.name}</h4>

                  <MdEdit
                    size={22}
                    style={{ marginLeft: 5, cursor: "pointer" }}
                    onClick={() => {
                      setId(item.id);
                      setName(item.name);
                      setOrder(item.order);
                      setDescription(item.description);
                      setVisibleModalModule(true);
                    }}
                  />
                  <MdDelete
                    size={20}
                    style={{ marginLeft: 5, cursor: "pointer" }}
                    onClick={() => {
                      confirm({
                        okText: "Confirmar",
                        title: `Deseja excluir o modulo de ${item.name}?`,
                        icon: <ExclamationCircleFilled />,
                        content: `Após confirmação, o modulo será excluido`,
                        onOk() {
                          deleteModule(item.id);
                        },
                        onCancel() {},
                        cancelText: "Cancelar",
                      });
                    }}
                  />
                  <p>{item.name}</p>
                </div>

                {loading ? (
                  <Spin style={{ marginTop: 50 }} size="large" />
                ) : (
                  <>
                    {item.courses?.length == 0 && (
                      <Message>Nenhum curso encontrado</Message>
                    )}
                    <div className="courses">
                      {item.courses?.map((item) => {
                        return (
                          <div className="course">
                            <p>{item.name}</p>
                            <img src={item.photo_url} />
                            <div>
                              <Button
                                type="primary"
                                onClick={() => {
                                  navigate(`/admin/lessons/${item.id}`);
                                }}
                              >
                                <MdBook size={14} />
                                Aulas
                              </Button>
                              <Button
                                className="warning-button"
                                onClick={() => {
                                  setId(item.id);
                                  setName(item.name);
                                  setOrder(item.order);
                                  setModule_id(item.module_id);
                                  setDescription(item.description);
                                  setPhoto({ photo_url: item.photo_url });
                                  setVisibleModal(true);
                                }}
                              >
                                <MdEdit size={14} />
                                Editar
                              </Button>
                              <Button
                                className="delete-button"
                                onClick={() => {
                                  confirm({
                                    okText: "Confirmar",
                                    title: `Deseja excluir o curso de ${item.name}?`,
                                    icon: <ExclamationCircleFilled />,
                                    content: `Após confirmação, o curso será excluido`,
                                    onOk() {
                                      deleteCourse(item.id);
                                    },
                                    onCancel() {},
                                    cancelText: "Cancelar",
                                  });
                                }}
                              >
                                <MdDelete size={14} />
                                Deletar
                              </Button>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </>
                )}
              </div>
            );
          })}
        </>
      )}

      <Modal
        title={id ? "Editar Modulo" : "Novo Modulo"}
        width={500}
        confirmLoading={isLoadingModal}
        open={visibleModalModule}
        okText={"SALVAR"}
        cancelText="FECHAR"
        onOk={() => {
          createAndEditModule();
        }}
        onCancel={() => {
          setVisibleModalModule(false);
        }}
      >
        <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <ViewInput>
            <p>Nome do Modulo*</p>
            <Input
              placeholder="aprendendo..."
              value={name}
              onChange={(event) => setName(event.target.value)}
            />
          </ViewInput>
          <ViewInput>
            <p>Ordem do Modulo*</p>
            <Input
              placeholder="0"
              value={order}
              onChange={(event) =>
                setOrder(event.target.value.replace(/\D/g, ""))
              }
            />
          </ViewInput>
          <ViewInput>
            <p>Descrição do Modulo*</p>
            <Input.TextArea
              style={{ minHeight: 80 }}
              placeholder="aprendendo..."
              value={description}
              onChange={(event) => setDescription(event.target.value)}
            />
          </ViewInput>
        </div>
      </Modal>
      <Modal
        title={id ? "Editar Curso" : "Novo Curso"}
        width={500}
        confirmLoading={isLoadingModal}
        open={visibleModal}
        okText={"SALVAR"}
        cancelText="FECHAR"
        onOk={() => {
          createAndEditCourse();
        }}
        onCancel={() => {
          setVisibleModal(false);
        }}
      >
        <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <ViewInput>
            <p>Banner do Curso (21x7 recomendado)*</p>
            <div
              style={{
                marginTop: 0,
                width: "100%",
                height: 180,
                borderRadius: 10,
                marginBottom: 12,
                justifyContent: "center",
              }}
            >
              <img
                style={{
                  width: "100%",
                  height: 160,
                  borderRadius: 10,
                  background: "#fff",
                }}
                src={
                  photo.photo_url
                    ? photo.photo_url
                    : "https://img.freepik.com/vetores-gratis/vetor-de-banner-moderno-mosaico-geometrico-cinza-e-branco_1055-10918.jpg?w=2000"
                }
              />
              <IconButton style={{ width: 40, height: 40 }}>
                <label
                  for="avatar"
                  style={{
                    display: "flex",
                    width: 50,
                    height: 50,
                    justifyContent: "center",
                    alignItems: "center",
                    cursor: "pointer",
                  }}
                >
                  <MdAddPhotoAlternate color="#000" />
                  <input
                    id="avatar"
                    style={{ display: "none" }}
                    type="file"
                    accept="image/"
                    onChange={(file) => {
                      let photo = file.target.files[0];
                      photo.photo_url = URL.createObjectURL(
                        file.target.files[0]
                      );
                      setPhoto(photo);
                    }}
                  />
                </label>
              </IconButton>
            </div>
          </ViewInput>
          <ViewInput>
            <p>Nome do Curso*</p>
            <Input
              placeholder="aprendendo..."
              value={name}
              onChange={(event) => setName(event.target.value)}
            />
          </ViewInput>
          <ViewInput>
            <p>Modulo do Curso*</p>
            <Select
              style={{ width: "100%", textAlign: "left" }}
              placeholder="selecionar modulo"
              value={module_id}
              onChange={(value) => setModule_id(value)}
            >
              {courses.map((item) => {
                if (item.id) {
                  return (
                    <Select.Option value={item.id}>{item.name}</Select.Option>
                  );
                }
              })}
            </Select>
          </ViewInput>
          <ViewInput>
            <p>Ordem do Curso*</p>
            <Input
              placeholder="0"
              value={order}
              onChange={(event) =>
                setOrder(event.target.value.replace(/\D/g, ""))
              }
            />
          </ViewInput>
          <ViewInput>
            <p>Descrição do Curso*</p>
            <Input.TextArea
              style={{ minHeight: 80 }}
              placeholder="aprendendo..."
              value={description}
              onChange={(event) => setDescription(event.target.value)}
            />
          </ViewInput>
        </div>
      </Modal>
    </Container>
  );
}
